import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OffersState } from '~/src/redux/offers/offers.types';

const initialState = new OffersState();

const offersSlice = createSlice({
    name: 'offers',
    initialState,
    reducers: {
        setOfferBlobLinkAction: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                offerBlobLink: action.payload,
            };
        },
        setCodexBlobLinkAction: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                codexBlobLink: action.payload,
            };
        },
        setDocumentationBlobLinkAction: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                documentationAPIBlobLink: action.payload,
            };
        },
        setInstructionLinkAction: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                instructionUserManualLink: action.payload,
            };
        }
    },
});

export const { setOfferBlobLinkAction, setDocumentationBlobLinkAction, setCodexBlobLinkAction, setInstructionLinkAction } = offersSlice.actions;
export const offersReducer = offersSlice.reducer;
